const identity = (value: unknown) => value;

export default identity;
